export const X_AUTH_TOKEN = "X-Auth-Token";
export const X_AUTH_REFRESH_TOKEN = "X-Auth-Refresh-Token";
export const ACCESS_TOKEN_UNIQUE_ID = "Access-Token-Unique-Id";

export enum Status {
    PENDING = 0,
    APPROVED = 1,
    CANCELED = -1,
}
